export default __webpack_public_path__ + "static/media/KahshLabs.4246cede.png";